export const removeConsoles = () => {
    if (process.env.NODE_ENV === 'production') {
        console.log = () => {}
        console.error = () => {}
        console.debug = () => {}
        console.group = () => {}
        console.groupCollapsed = () => {}
        console.warn = () => {}
    }
}